export enum DataValueStyle {
    None,
    Zero,
    Warn
}